(() => {
  const storageKey = 'anaghaya_lead_attribution_v1';
  const pendingLeadKey = 'anaghaya_pending_lead_reference';
  const storageLifetime = 90 * 24 * 60 * 60 * 1000;
  const campaignKeys = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'gclid',
    'gbraid',
    'wbraid',
    'fbclid',
  ];

  const readStoredAttribution = () => {
    try {
      const stored = JSON.parse(window.localStorage.getItem(storageKey));

      if (!stored || !stored.saved_at || Date.now() - stored.saved_at > storageLifetime) {
        window.localStorage.removeItem(storageKey);
        return {};
      }

      return stored;
    } catch (_error) {
      return {};
    }
  };

  const writeStoredAttribution = (attribution) => {
    try {
      window.localStorage.setItem(storageKey, JSON.stringify(attribution));
    } catch (_error) {
      // Attribution is an enhancement; form submission must still work when storage is unavailable.
    }
  };

  const getCurrentAttribution = () => {
    const query = new URLSearchParams(window.location.search);
    const stored = readStoredAttribution();
    const hasCampaignParameter = campaignKeys.some((key) => query.has(key));
    const attribution = {
      ...stored,
      first_landing_page: stored.first_landing_page || window.location.href,
      first_referrer: stored.first_referrer || document.referrer || 'Direct',
      saved_at: Date.now(),
    };

    if (hasCampaignParameter) {
      campaignKeys.forEach((key) => {
        attribution[key] = query.get(key) || '';
      });
    }

    writeStoredAttribution(attribution);
    return attribution;
  };

  const attribution = getCurrentAttribution();
  const leadForm = document.getElementById('CorporateGiftingForm');
  const pendingLeadReference = (() => {
    try {
      return window.sessionStorage.getItem(pendingLeadKey) || '';
    } catch (_error) {
      return '';
    }
  })();

  leadForm?.querySelectorAll('[data-lead-field]').forEach((field) => {
    const key = field.dataset.leadField;
    const value = key === 'page_url' ? window.location.href : attribution[key];

    if (value) field.value = value;
  });

  const leadReferenceField = leadForm?.querySelector('[data-lead-reference]');
  if (leadReferenceField) {
    leadReferenceField.value = window.crypto?.randomUUID
      ? `anaghaya-${window.crypto.randomUUID()}`
      : `anaghaya-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;

    leadForm.addEventListener('submit', () => {
      try {
        window.sessionStorage.setItem(pendingLeadKey, leadReferenceField.value);
      } catch (_error) {
        // The native Shopify contact form remains fully functional without session storage.
      }
    });
  }

  const modal = document.querySelector('[data-lead-success-modal]');
  if (!modal) return;

  if (modal.parentElement !== document.body) document.body.appendChild(modal);

  const closeButtons = modal.querySelectorAll('[data-lead-modal-close]');
  const focusTarget = modal.querySelector('.ag-lead-success__close');
  const previousActiveElement = document.activeElement;

  const closeModal = () => {
    modal.hidden = true;
    document.body.classList.remove('ag-lead-modal-open');
    document.removeEventListener('keydown', handleKeydown);

    if (previousActiveElement instanceof HTMLElement) previousActiveElement.focus();
  };

  const handleKeydown = (event) => {
    if (event.key === 'Escape') closeModal();

    if (event.key === 'Tab') {
      const focusable = Array.from(
        modal.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')
      ).filter((element) => !element.hidden);

      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  };

  closeButtons.forEach((button) => button.addEventListener('click', closeModal));
  document.addEventListener('keydown', handleKeydown);
  document.body.classList.add('ag-lead-modal-open');
  window.requestAnimationFrame(() => focusTarget?.focus());

  const eventData = {
    leadType: modal.dataset.leadType || 'gifting_enquiry',
    formId: modal.dataset.formId || 'lead_form',
    pagePath: window.location.pathname,
    source: attribution.utm_source || 'direct',
    medium: attribution.utm_medium || 'none',
    campaign: attribution.utm_campaign || 'none',
    leadReference: pendingLeadReference || 'unavailable',
  };

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'anaghaya_lead_submitted',
    lead_type: eventData.leadType,
    form_id: eventData.formId,
    page_path: eventData.pagePath,
    campaign_source: eventData.source,
    campaign_medium: eventData.medium,
    campaign_name: eventData.campaign,
    lead_reference: eventData.leadReference,
  });

  if (window.Shopify?.analytics?.publish) {
    window.Shopify.analytics.publish('anaghaya:lead_submitted', eventData);
  }

  document.dispatchEvent(new CustomEvent('anaghaya:lead-submitted', { detail: eventData }));

  try {
    window.sessionStorage.removeItem(pendingLeadKey);
  } catch (_error) {
    // Nothing to clear when session storage is unavailable.
  }

  const currentUrl = new URL(window.location.href);
  if (currentUrl.searchParams.get('contact_posted') === 'true') {
    currentUrl.searchParams.delete('contact_posted');
    window.history.replaceState({}, '', `${currentUrl.pathname}${currentUrl.search}${currentUrl.hash}`);
  }
})();
